module.exports = __webpack_public_path__ + "img/monsor2.e70291db.jpg";